/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs */

const en_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi wired in when content must stay editable by non-developers, live preview included.`)
};

const ar_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity أو Strapi يُوصَّلان حين يجب أن يبقى المحتوى قابلًا للتعديل من غير المطورين, مع معاينة مباشرة.`)
};

const bn_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কনটেন্ট যখন অ-ডেভেলপারদের এডিটযোগ্য রাখতে হবে তখন Sanity/Strapi, লাইভ প্রিভিউসহ।`)
};

const de_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi wird eingebunden, wenn Inhalte von Nicht-Entwicklern pflegbar bleiben müssen, inklusive Live-Vorschau.`)
};

const es_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi se incluye cuando el contenido debe seguir siendo editable por personas que no sean desarrolladores, incluida la vista previa en vivo.`)
};

const fr_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi est connecté lorsque le contenu doit rester modifiable par des non-développeurs, aperçu en direct inclus.`)
};

const pt_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi conectado quando o conteúdo deve permanecer editável por não desenvolvedores, incluindo visualização ao vivo.`)
};

const zh_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容需要给非开发维护时，就接上 Sanity/Strapi，带实时预览。`)
};

const tr_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçerik, geliştirici olmayanlarca düzenlenebilir kalacaksa Sanity/Strapi gömülür, canlı önizleme dahil.`)
};

const ru_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi подключается, когда контент должны править не разработчики, плюс живое превью.`)
};

const pl_svc_full_stack_web_apps_cms_desc3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity/Strapi podłączone, gdy treść musi pozostać edytowalna dla osób niebędących programistami, łącznie z podglądem na żywo.`)
};

/**
* | output |
* | --- |
* | "Sanity/Strapi wired in when content must stay editable by non-developers, live preview included." |
*
* @param {Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_cms_desc3 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Cms_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_cms_desc3(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_cms_desc3(inputs)
	return en_svc_full_stack_web_apps_cms_desc3(inputs)
});
export { svc_full_stack_web_apps_cms_desc3 as "svc_full-stack-web-apps_CMS_desc" }